import Button from '../../../common/components/button/button';
import { ROUTES } from '../../../core/constants/routes';

import '../styles/standalone.css';

export default function UnauthorizedScreen() {
    return (
        <main className="standalone">
            <div className="standalone__panel">
                <span className="standalone__mark" aria-hidden="true">M</span>
                <h1 className="standalone__title">No tienes acceso a esta sección</h1>
                <p className="standalone__text">
                    Tu sesión no incluye el permiso necesario. Si crees que es un error, pide a un administrador que lo revise en Core.
                </p>
                <Button variant="primary" to={ROUTES.HOME}>Ir al inicio</Button>
            </div>
        </main>
    );
}
